<template>
<section class="footer_menu" v-if="footer">
    <div class="wrap">
        <ul>
            <li :class="[{ 'now' : routeName == 'Main' }]">
                <router-link to="/main">
                    <img :src="`${$store.state.dir}images/${routerNameCheck('Main')}home.png`">
                </router-link>
            </li>
            <li :class="[{ 'now' : routeName == 'MyBookingList' }]">
                <router-link to="/myBookingList">
                
                    <img :src="`${$store.state.dir}images/${routerNameCheck('MyBookingList')}calendar.png`">
                    <span class="dot" v-if="auth.bookingAlarmCount > 0"></span>
                </router-link>
            </li>
            <li :class="[{ 'now' : routeName == 'Menu' }]">
                <router-link to="/menu">
                    <img :src="`${$store.state.dir}images/${routerNameCheck('Menu')}menu.png`">
                </router-link>
            </li>
        </ul>
    </div>
    
</section>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'Footer',
    computed: {
        ...mapState({
            footer : state => state.footer,
        }),
        routeName(){
            return this.$route.name;
        }
    },
    methods: {
        routerNameCheck(name) {
            return (this.routeName == name) ? 'now_': '';
        }
    },
}
</script>

<style lang="scss" scoped>

</style>